export const SAFETOTAL_WEB_API: string = 'http://localhost:8090';